/**
 * The NSB mark and wordmark (public/brand, drawn from Jason's Illustrator
 * lockup: the thin-seam cone left, the wordmark right). Each is a mask filled
 * with the text colour, so one file serves paper and sumi alike.
 */
function BrandArt({ src, ratio, className }: { src: string; ratio: number; className: string }) {
  const mask = `url(${src}) center / contain no-repeat`;
  return <span aria-hidden="true" className={`shrink-0 bg-current ${className}`} style={{ aspectRatio: ratio, mask, WebkitMask: mask }} />;
}

/** The header lockup: the cone, the wordmark, a hairline, and what this is. */
export function Lockup() {
  return (
    <span className="flex items-center gap-3 text-ink">
      <BrandArt src="/brand/nsb-mark.svg" ratio={0.9811} className="block h-7" />
      <BrandArt src="/brand/nsb-wordmark.svg" ratio={9.7803} className="hidden h-[15px] sm:block" />
      <span className="hidden h-4 w-px bg-rule-strong sm:block" aria-hidden="true" />
      <span className="label hidden !text-[0.625rem] !text-ink-3 sm:inline">Build portal</span>
    </span>
  );
}

/** Jason's lockup exactly as drawn, for the sign-in page. */
export function BrandLockup() {
  return (
    <span className="block text-ink">
      <BrandArt src="/brand/nsb-lockup.svg" ratio={4.6298} className="block h-11 sm:h-12" />
    </span>
  );
}
